import React from "react";
import CardClaim from "./card.claim.general";
import { useClaimsPageSponsors } from "../../../services/microservice/agents/sponsors/use-sponsors";

const ClaimsComponent = () => {
  const { data: sponsors, isLoading, isError } = useClaimsPageSponsors();

  return (
    <section className="flex w-full justify-center p-0">
      <div className="container w-full px-6 py-24 lg:px-20">
        {isLoading ? (
          <div className="flex w-full justify-center py-20">
            <div className="border-textSecundary border-t-background h-16 w-16 animate-spin rounded-full border-8" />
          </div>
        ) : isError || !sponsors?.length ? (
          <p className="text-textBlack text-center text-xl">
            No hay reclamaciones disponibles en este momento.
          </p>
        ) : (
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
            {sponsors.map((sponsor) => (
              <CardClaim
                key={sponsor.idSystem || sponsor.slug}
                {...sponsor}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ClaimsComponent;
